import { Module } from "vuex";
import { RootState } from "../types";
import { IntAddCanidates } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as IntAddCanidates;

export const addCanidates: Module<IntAddCanidates, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
